import { JSX } from "react";

import { Pane, TileLayer } from "react-leaflet";

const styles = {
  tilePane: { zIndex: 10, filter: "grayscale(100%)" },
};

function GeoMapLayer(): JSX.Element {
  return (
    <Pane name='tile-pane' style={styles.tilePane}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        maxZoom={21}
        maxNativeZoom={19}
      />
    </Pane>
  );
}

export default GeoMapLayer;
